export default {"src":"/_next/static/media/eventRightArrowIcon.f315e9e8.svg","height":23,"width":23,"blurWidth":0,"blurHeight":0};